<template>
  <div>
    <div class="panel-heading top-margin">
      <div class="panel-title">Transaction {{ transactionId }}</div>
    </div>
    <div class="row notification">
      <div class="col-md-12">
        <slot></slot>
      </div>
    </div>
    <div class="row transation-info">
      <div class="col-md-6">
        <div class="row first-row">
          <div class="col-md-6 left-padding">
            <label class="title">Transaction date:</label>
          </div>

          <div class="col-md-6 left-padding">
            <label class="value">{{ formatDate(maturityDate) }}</label>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 left-padding">
            <label class="title">Note number:</label>
          </div>
          <div class="col-md-6 left-padding">
            <label class="value">{{ noteId }}</label>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row first-row">
          <div class="col-md-6 left-padding">
            <label class="title">Payment type:</label>
          </div>

          <div class="col-md-6 left-padding">
            <label class="value">{{ getPaymentType }}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 left-padding">
            <label class="title">Amount:</label>
          </div>

          <div class="col-md-6 left-padding">
            <label class="value">{{ formatAmount(amount) }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="line-separator top-margin"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { formatAmount, formatDate } from '@/util';
import TransactionTypes from '@/data/static/transactionTypes'; // eslint-disable-line no-unused-vars

const mix = {
  methods: {
    formatDate,
    formatAmount,
  },
};

export default {
  name: 'UpcomingTransactionsData',
  mixins: [mix],
  props: {
    transactionId: {
      type: String,
      default: '',
    },
    maturityDate: {
      type: String,
    },
    noteId: {
      type: String,
      default: '',
    },
    paymentType: {
      type: String,
      default: '',
    },
    amount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    getPaymentType() {
      const { paymentType } = this;
      return paymentType === TransactionTypes.INT_PAID ||
        paymentType === TransactionTypes.INT_DONATE ||
        paymentType === TransactionTypes.INT_REINVEST
        ? 'Interest payment'
        : 'Principal payment';
    },
  },
};
</script>
<style scoped>
.panel-heading {
  color: #444;
  background-color: #ffffff;
  border-color: #cfdbe2;
  border-bottom: 0;
  padding: 0;
}
.panel-title .fa {
  margin-right: 10px;
}
.panel .panel .panel-title {
  margin-bottom: 15px;
  font-size: 16px;
}
.top-margin {
  margin-top: 2%;
}
.transation-info {
  margin: 20px 0px 20px 0px;
}
.notification {
  margin-top: 20px;
}
.alert {
  padding: 20px 10px 20px 10px;
}
label.title {
  color: #909fa6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
label.value {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.first-row {
  margin-bottom: 10px;
}
.left-padding {
  padding-left: 0;
}
.line-separator {
  padding: 8px;
  line-height: 1.52857143;
  vertical-align: top;
  border-top: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// UpcomingTransactionsData.vue?0318d271